import { useTranslation } from '@frontend/i18n';
import { BulkEmailPrefixes } from '@frontend/tracking-prefixes';
import { useContentComposer } from '../../content-composer/content-composer-provider';
import { ToolboxButton } from '../../content-composer/toolbox-atoms/toolbox-button';
import { CustomCodeSection } from './custom-code-section';

export const CustomCodeTool = () => {
  const { t } = useTranslation('content-composer');
  const { insertSection } = useContentComposer();

  return (
    <ToolboxButton
      icon='terminal'
      title={t('Custom Code')}
      subtitle={t('Add custom HTML and CSS.')}
      onClick={() => insertSection(<CustomCodeSection />)}
      trackingId={`${BulkEmailPrefixes.Composer}-custom-code-tool-btn`}
    >
      <CustomCodeSection />
    </ToolboxButton>
  );
};
